import actionsFile from "./actions";

export default {
  namespaced: true,
  actions: actionsFile,
};
